import PropTypes from "prop-types";
import { alignItems, colors, strCode } from "../../consts";
import FlexContainers from "../Containers/FlexContainers";
import WrapperContainer from "../Containers/WrapperContainer";
import GradientLoader from "../GradientLoader/GradientLoader";
import TextOverflowWrapper from "../TextOverflowWrapper/TextOverflowWrapper";
import { DeviceImageContainer } from "./styled";
import { t } from "../../services";

const DeviceInfo = ({
  isLoading,
  isImageLoaded,
  setIsImageLoaded,
  imageSrc,
  width,
  model,
  type
}) => {
  return (
    <WrapperContainer Container={FlexContainers.FlexRowStart} gap={16} width={`${width}px`}>
      <DeviceImageContainer Container={FlexContainers.FlexRowCenter}>
        {(isLoading || !isImageLoaded) && (
          <GradientLoader width={48} height={48} animationDuration={48} borderRadius={8} />
        )}
        <img
          src={imageSrc}
          alt="device"
          style={{ display: isImageLoaded && !isLoading ? "block" : "none" }}
          onLoad={() => setIsImageLoaded(true)}
        />
      </DeviceImageContainer>

      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        maxWidth={`${width - 54}px`}
        gap={isLoading ? 4 : 0}>
        <TextOverflowWrapper
          maxWidth={`${width - 54}px`}
          style={{ color: colors.RAISIN_100, fontWeight: 600 }}>
          {isLoading ? (
            <GradientLoader width={width} height={24} animationDuration={40} />
          ) : (
            t(model ?? strCode.UNKNOWN)
          )}
        </TextOverflowWrapper>

        <TextOverflowWrapper
          style={{
            color: colors.RAISIN_70,
            fontWeight: 500,
            fontSize: "14px"
          }}>
          {isLoading ? (
            <GradientLoader width={`${width - 54}px`} height={24} animationDuration={40} />
          ) : (
            type ?? t(strCode.EMPTY_CELL_INFO)
          )}
        </TextOverflowWrapper>
      </WrapperContainer>
    </WrapperContainer>
  );
};

DeviceInfo.propTypes = {
  isLoading: PropTypes.bool,
  isImageLoaded: PropTypes.bool,
  setIsImageLoaded: PropTypes.func.isRequired,
  imageSrc: PropTypes.string,
  width: PropTypes.number.isRequired,
  model: PropTypes.model,
  type: PropTypes.type
};

export default DeviceInfo;
